/**
 * TanStack Router: /performance/feedbacks
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceFeedbacksPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceFeedbacksPage from '@/app/performance/feedbacks/page'

/**
 * Route: /performance/feedbacks
 * Layout: _auth (authenticated)
 * Component: PerformanceFeedbacksPage
 */
export const Route = createFileRoute('/_auth/performance/feedbacks/')({
  component: PerformanceFeedbacksPage,
})
